module.exports = __webpack_public_path__ + "static/Symphonia0-701ed308fd9d28d871223c68422e5d7f.webp";